/**
 * Serializes a params object into a URL query string.
 * Array values are expanded as repeated keys (`key=a&key=b`).
 * @param params - Key/value map; array values are spread.
 */
export const toQueryString = (params: Record<string, any>): string => {
	const searchParams = new URLSearchParams()

	for (const key in params) {
		const value = params[key]

		if (Array.isArray(value)) {
			value.forEach((v) => searchParams.append(key, String(v)))
		} else {
			searchParams.append(key, String(value))
		}
	}

	return searchParams.toString()
}
